<template>
  <div class="prodcutDetail">
    <div v-if="noProduct">
      <van-empty description="暂无货品信息" />
    </div>
    <div v-if="!noProduct">
      <van-tabs v-model="active" scrollspy sticky :line-height="0" title-active-color="#333"
        v-if="!flag || description.length > 0">
        <van-tab title="基础信息">
          <BaseInfo class="baseInfo" v-if="Object.keys(productImg).length !== 0" :basicInfoData="basicInfoData"
            :productImg="productImg" :productAllInfo="productAllInfo" :barCode="barCode" :skuSn="skuSn"
            :thirdUniqueCode="thirdUniqueCode" />
        </van-tab>
        <van-tab title="石料信息" v-if="stoneInfoData.length !== 0">
          <StoneInfo :stoneInfoData="stoneInfoData" />
        </van-tab>

        <van-tab title="质检信息" v-if="QualityCertificate">
          <QualityCheck :QualityCertificate="QualityCertificate" :QualityCertificateImg="QualityCertificateImg"
            :barCode="barCode" :certificateSn="certificateSn" />
        </van-tab>
        <van-tab title="溯源信息" v-if="description.length !== 0">
          <AddInfo :description="description" />
        </van-tab>
      </van-tabs>
      <BaseInfo class="baseInfo" v-else :basicInfoData="basicInfoData" :productImg="productImg"
        :productAllInfo="productAllInfo" :barCode="barCode" :skuSn="skuSn" :thirdUniqueCode="thirdUniqueCode" />
      <template v-if="basicInfoData && basicInfoData.list && basicInfoData.list.productJumpSXFlag">
        <div class="fixed-btn">
          <img src="../../assets/sixia.png" alt="" />
          <span>进入司匣</span>
          <wx-open-launch-weapp id="launch-btn" :appid="rentAppid" :env-version="env" :path="`pages/tabbar/root`"
            @error="handleErrorFn" @launch="handleLaunchFn"
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
            <component :is="'script'" type="text/wxtag-template">
              <component :is="'style'">
                .open-btn{ position: absolute; left:0;right:0;bottom:0;top:0;width:100%;height:100%;}
              </component>
              <div class="open-btn"></div>
            </component>
          </wx-open-launch-weapp>
        </div>
      </template>
    </div>
    <FloatWindow v-if="barCode" :barCode="barCode" :canUseRent="canUseRent"></FloatWindow>
  </div>
</template>

<script>
import BaseInfo from "./baseInfo";
import StoneInfo from "./stoneInfo";
import AddInfo from "./addInfo";
import QualityCheck from "./qualityCheck";
import FloatWindow from "./floatWindow";
import { getProductDetail, getProductDetailBySkuSn, canRent } from "@/api/product.js";
import { getlifeLogOut } from "@/api/sourceInfo";

import { scanLog } from "@/api/scanLog";
export default {
  data() {
    return {
      active: 0,
      activeTwo: 0,
      productAllInfo: {},
      basicInfoData: {},
      productImg: {},
      QualityCertificateImg: [],
      QualityCertificate: null,
      stoneInfoData: [],
      addInfoData: [],
      flag: false,
      noProduct: false,
      barCode: "",
      skuSn: "",
      thirdUniqueCode: "",
      certificateSn: "",
      description: [],
      canUseRent: false,
      rentAppid: "wx696a7c544f07b23c",
      env: 'release',
    };
  },
  components: {
    BaseInfo,
    StoneInfo,
    AddInfo,
    QualityCheck,
    FloatWindow,
  },
  created() {
    let barCode = this.resolveBarCode();
    let skuSn = this.$route.params.skuSn || this.$route.query.skuSn || this.$route.query.s || "";
    let userAgent = window.navigator.userAgent;
    if (!barCode && !skuSn) {
      this.noProduct = true;
      return;
    } else {
      this.barCode = barCode;
      this.skuSn = skuSn;
    }
    console.log(barCode, "barCode");
    console.log(skuSn, "skuSn");
    if (this.skuSn) {
      this.fetchProduct(0, skuSn);
    } else if (this.barCode) {
      this.featchScanLog(barCode, userAgent);
      console.log(userAgent, "userAgent");
      this.fetchProduct(barCode);
      getlifeLogOut({ barCode: this.barCode }).then((res) => {
        this.description = res.data.data.list;
      });
    }
    if (location.protocol === 'http:') this.env = 'trial';
  },
  methods: {
    resolveBarCode() {
      let barCode = this.$route.params.barCode || this.$route.query.b;
      if (!barCode) {
        barCode = location.search.split("?")[1].split("=")[1];
      }
      return barCode === '0' ? '' : barCode;
    },
    featchScanLog(barCode, userAgent) {
      scanLog({ barCode, userAgent });
    },
    // 打开失败
    handleErrorFn(e) {
      console.log("launch-weapp：err", e);
    },
    // 打开app成功
    handleLaunchFn(e) {
      console.log("launch-weapp：success", e);
    },
    async fetchProduct(barCode, skuSn) {
      let res = {};
      if (skuSn) {
        res = await getProductDetailBySkuSn({ skuSn });
      } else {
        res = await getProductDetail({ barCode });
      }
      if (res.data.data === null || res.data.data.wmsProductVO === null) {
        this.noProduct = true;
      } else {

        const wmsCodeVO = res.data.data.wmsCodeVO || {};
        const wmsProductVO = res.data.data.wmsProductVO || {};
        this.productAllInfo = res.data.data || {};
        this.productImg = wmsProductVO;
        this.$set(this.basicInfoData, "list", wmsProductVO);
        if (wmsCodeVO) {
          this.$set(this.basicInfoData.list, "barCode", wmsCodeVO.barCode);
          this.productImg.weight = wmsCodeVO.metalWeight;
          this.thirdUniqueCode = wmsCodeVO.thirdUniqueCode;
          if (wmsCodeVO.thirdUniqueCode) this.canUseRent = true;
        }
        console.log(this.basicInfoData, "basic");
        console.log(res.data.data, "res.data.data");
        this.certificateSn =
          res.data.data.wmsProductSnQualityCertificateVO == null
            ? null
            : res.data.data.wmsProductSnQualityCertificateVO.certificateSn;

        this.stoneInfoData = res.data.data.wmsProductStoneVOList || [];
        this.addInfoData = res.data.data.wmsProductPropVOList;
        this.QualityCertificate =
          res.data.data.wmsProductSnQualityCertificateVO;
        if (this.QualityCertificate) {
          const { certificateFrontUrl, certificateBackUrl } = this.QualityCertificate || {};
          if (certificateFrontUrl) this.QualityCertificateImg.push(certificateFrontUrl);
          if (certificateBackUrl) this.QualityCertificateImg.push(certificateBackUrl);
        }
        if (this.stoneInfoData.length === 0 && !this.QualityCertificate) {
          this.flag = true;
        }
        // const { data } = await canRent({ sn: res.data.data.wmsProductVO.sn });
      }
    },
    // console.log(res.data.data, "productDetail");
    // this.basicInfoData = res.data.data.wmsProductVO;
    // this.basicInfoData["barCode"] = "666099153634";
    // this.basicInfoData["metalWeight"] =
    //   this.basicInfoData["metalWeight"] + "g";
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-tabs__wrap {
  height: 56px;

  .van-tabs__nav--line {
    padding-bottom: 0 !important;
  }

  .van-tab {
    color: #666666;
    font-size: 30px;
  }

  .van-tab--active {
    color: #333;
    font-size: 32px;
    font-family: PingFang SC, PingFang SC;
  }
}

::v-deep .van-tab__text--ellipsis {
  overflow: visible;
}

.prodcutDetail {
  // padding: 0 40px;
  background: #ededed;
  min-height: 100vh;
  position: relative;
  padding-bottom: 40px;

  .baseInfo {
    margin: 0 auto;
  }


  .logo {
    width: 304px;
    height: 215px;
    background: url("../../assets/noProduct.webp") no-repeat;
    background-size: cover;
    margin: 0 auto;
    margin-top: 295px;
  }

  .tip {
    width: 280px;
    height: 40px;
    color: rgba(51, 51, 51, 1);
    font-size: 28px;
    font-weight: bold;
    margin: 0 auto;
    margin-top: 40px;
  }
}

::v-deep .van-tabs__content {
  background: #ededed;
}

.myTable {
  margin-top: 10px;
}

.imgTitle {
  padding: 0 20px;
}

.imgList {
  margin-top: 50px;
}

.otherStone {
  margin-top: 10px;
}

.checkTitle {
  margin-top: 100px;
}

img {
  margin: 0 auto;
  width: 500px;
  height: 500px;
}

.fixed-btn {
  position: fixed;
  top: 50%;
  right: 16px;
  width: 96px;
  height: 116px;
  font-size: 20px;
  line-height: 28px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border-radius: 8px 8px 8px 8px;
  opacity: 0.65;
  text-align: center;
  z-index: 2;

  span {
    display: block;
    color: #333333;
  }

  img {
    margin: 16px auto 8px;
    width: 56px;
    height: 56px;
    vertical-align: top;
  }
}
</style>
